import { useGetApiV1ExamExamidLangsAvailable } from '@/shared/api/generated';

/**
 * Hook para listar os idiomas ainda não adicionados a uma prova.
 *
 * Só executa a query quando `examId` for maior que zero.
 *
 * @param examId - ID da prova cujos idiomas disponíveis serão buscados
 * @returns Lista de idiomas disponíveis com estado de loading
 *
 * @example
 * ```tsx
 * const { availableLangs, isLoading } = useAvailableExamLangs(examId);
 * ```
 */
export function useAvailableExamLangs(examId: number) {
  const { data = [], isLoading } = useGetApiV1ExamExamidLangsAvailable(examId, {
    query: { enabled: examId > 0 },
  });

  return { availableLangs: data, isLoading } as const;
}
